export const UPDATE_BUDGET_VALUE = 'UPDATE_BUDGET_VALUE'
export const UPDATE_EQUITY_BUYBACK = 'UPDATE_EQUITY_BUYBACK'
export const UPDATE_CALCULATOR_CONFIG = 'UPDATE_CALCULATOR_CONFIG'
export const UPDATE_CALCULATOR_CONFIG_2 = 'UPDATE_CALCULATOR_CONFIG_2'

export function updateCalculatorConfig (config, includeYearZero) {
  return {
    type: UPDATE_CALCULATOR_CONFIG,
    config,
    includeYearZero
  }
}

export function updateCalculatorConfig2 (config) {
  return {
    type: UPDATE_CALCULATOR_CONFIG_2,
    config
  }
}
